import React, { PureComponent } from 'react';
import { Box, Paper, TextField, FormLabel } from '@material-ui/core';
import { AutoSuggest, Chip, Radio, Slider } from 'common';
import { jobTitles, location } from 'controllers/taxonomies';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { uuid } from 'utils';
import { updateJob } from 'controllers/job';

class TheJob extends PureComponent {
  fetchJobTitles = async (value) => {
    const titles = await jobTitles(value);
    return await titles.response.map((title) => title['job title']);
  };

  fetchLocations = async (value) => {
    const locations = await location(value);
    return await locations.response.map(
      ({ name, country }) => `${name}, ${country}`
    );
  };

  onChangeOrganizationName = (e) => {
    const jobDetails = {
      company: e.target.value,
    };
    updateJob(jobDetails);
  };

  render() {
    const {
      company,
      jobRole,
      employmentType,
      jobLocationLocal,
      positionCount,
      locationArray,
      description,
      onDeleteLocation,
      onSelectLocation,
      onChangePositionCount,
      onSelectJobRole,
      onChangeHandlerDescription,
      onChange,
      onUpdateJobHandler,
      jobDescription,
      errorFlag,
    } = this.props;

    return (
      <>
        <Paper
          square
          elevation={0}
          className="the-job"
          id="the-job"
          style={{ position: 'relative' }}
        >
          <AutoSuggest
            placeholder={'Job Title ( required )'}
            value={jobRole}
            name="jobRole"
            onChange={onUpdateJobHandler}
            fetchSuggestions={this.fetchJobTitles}
            onSelect={onSelectJobRole}
            errorFlag={errorFlag && !jobRole}
            errorMessage="This field is required."
          />
          {/* <Paper
              square
              elevation={0}
              className="qualification"
              style={{
                position: 'absolute',
                left: 'calc(100% + 24px)',
                top: '-15px',
                width: '40.5%'
              }}
            >
              <Typography style={{fontSize:"16px",lineHeight:"19px",color:"#49515a"}}>Total pool size</Typography>
              <Typography>
                <span style={{fontSize:"32px",lineHeight:"38px",color:"#4b8c6f"}}>40,000 </span>
                <span style={{fontSize:"16px",lineHeight:"28px",color:"#49515a"}}>Candidates</span>
              </Typography>
          </Paper> */}
        </Paper>
        <Paper square elevation={0} className="the-job">
          <Box className={errorFlag && !Boolean(company) ? 'error' : ''}>
            <FormLabel component="legend" className="label">
              Add the company or client whom you are looking for
            </FormLabel>
            <TextField
              error={errorFlag && !Boolean(company)}
              label="Company"
              margin="normal"
              variant="outlined"
              value={company}
              onChange={this.onChangeOrganizationName}
              fullWidth
            />
            {errorFlag && !Boolean(company) ? (
              <p className="error-message">This field is required.</p>
            ) : (
              ''
            )}
          </Box>
        </Paper>
        <Paper square elevation={0} className="the-job">
          <Radio
            label="Type of position ( *required )"
            value={employmentType}
            onChange={onUpdateJobHandler}
            name="employmentType"
            errorFlag={errorFlag && !employmentType}
            errorMessage="This field is required."
            items={[
              {
                label: 'Full time',
                value: 'Fulltime',
              },
              {
                label: 'Part time',
                value: 'Parttime',
              },
              {
                label: 'Contract',
                value: 'Contract',
              },
              {
                label: 'Internship',
                value: 'Internship',
              },
            ]}
          />
        </Paper>
        <Paper square elevation={0} className="the-job">
          <Box className={errorFlag && !Boolean(positionCount) ? 'error' : ''}>
            <FormLabel component="legend" className="label">
              Number of position ( *required )
            </FormLabel>
            <Box p="20px 10px 0 10px" width="70%">
              <Slider
                max={50}
                value={positionCount}
                onChange={onChangePositionCount}
              />
            </Box>
            {errorFlag && !Boolean(positionCount) ? (
              <p className="error-message">This field is required.</p>
            ) : (
              ''
            )}
          </Box>
        </Paper>
        <Paper square elevation={0} className="the-job">
          <Box>
            <FormLabel component="legend" className="label">
              Describe the role so that we can find the best match.
            </FormLabel>
            <div className="RichEditor-root">
              <ReactQuill
                editorState={description}
                onChange={onChangeHandlerDescription}
                placeholder="Description"
                modules={TheJob.modules}
                formats={TheJob.formats}
                value={jobDescription}
              />
            </div>
          </Box>
        </Paper>
        <Paper square elevation={0} className="the-job">
          <FormLabel component="legend" className="label">
            Job Location ( *required )
          </FormLabel>
          <Box>
            <AutoSuggest
              placeholder={'Enter the Job Location'}
              value={jobLocationLocal}
              name="jobLocationLocal"
              onChange={onChange}
              fetchSuggestions={this.fetchLocations}
              onSelect={onSelectLocation}
              enableSelectionOnEnter
              errorFlag={errorFlag && !Boolean(locationArray.length)}
              errorMessage="This field is required."
            />
          </Box>
          {locationArray.map((location) => {
            return (
              <Chip
                key={uuid()}
                label={location}
                onDeleteChip={onDeleteLocation}
              />
            );
          })}
        </Paper>
      </>
    );
  }
}

TheJob.modules = {
  toolbar: [
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['bold', 'italic', 'underline', 'blockquote'],
    [{ size: [] }],
  ],
};

TheJob.formats = [
  'align',
  'list',
  'bullet',
  'bold',
  'italic',
  'underline',
  'blockquote',
  'size',
];
export default TheJob;
